<template>
  <div>
    <a-layout-sider class="sidebar" v-model:collapsed="collapsed" :trigger="null" collapsible style="min-height: 100vh">
      <sidebar-title :collapse="collapsed" />
      <a-menu
        v-model:selectedKeys="selectedKeys"
        v-model:openKeys="openKeys"
        mode="inline"
        :style="{ height: '100%', borderRight: 0 }"
      >
        <a-sub-menu v-if="newMenuList.length > 0" v-for="first in newMenuList" :key="first.path">
          <template #icon>
            <component :is="getIcon(first)" />
          </template>
          <template #title>{{first.name}}</template>
          <template v-for="(second, index) in first.children" :key="second.id">
            <a-menu-item :key="second.path" v-if="second.path != null" @click="handleClick(second)" :title="second.path">
                <a-tag v-if="second.path === '/moreIpAlarm' && alarmCount.alarm1 > 0" color="red">{{alarmCount.alarm1}}</a-tag>
                <a-tag v-if="second.path === '/moreDeviceAlarm' && alarmCount.alarm2 > 0" color="red">{{alarmCount.alarm2}}</a-tag>
                <a-tag v-if="second.path === '/ipDeviceAlarm' && alarmCount.alarm3 > 0" color="red">{{alarmCount.alarm3}}</a-tag>
              {{second.name}}
<!--              <router-link :to="second.path">-->
<!--                <a-tag v-if="second.path === '/moreIpAlarm' && alarmCount.alarm1 > 0" color="red">{{alarmCount.alarm1}}</a-tag>-->
<!--                <a-tag v-if="second.path === '/moreDeviceAlarm' && alarmCount.alarm2 > 0" color="red">{{alarmCount.alarm2}}</a-tag>-->
<!--                <a-tag v-if="second.path === '/ipDeviceAlarm' && alarmCount.alarm3 > 0" color="red">{{alarmCount.alarm3}}</a-tag>-->
<!--                {{second.name}}-->
<!--              </router-link>-->
            </a-menu-item>
            <a-sub-menu v-else :title="second.name" :key="second.path">
              <template v-for="third in second.children" :key="third.path">
                <a-menu-item @click="handleClick(third)" :title="third.path">{{third.name}}
<!--                  <router-link :to="third.path">{{third.name}}</router-link>-->
                </a-menu-item>
              </template>
            </a-sub-menu>
          </template>
        </a-sub-menu>
        <template v-else v-for="(menu, index) in menuList" :key="index">
          <a-menu-item v-if="!menu.children" :key="menu.path">
            <!-- <template #icon>
              <user-outlined />
            </template> -->
            <router-link :to="menu.path">
              <a-tag v-if="menu.path === '/moreIpAlarm' && alarmCount.alarm1 > 0" color="red">{{alarmCount.alarm1}}</a-tag>
              <a-tag v-if="menu.path === '/moreDeviceAlarm' && alarmCount.alarm2 > 0" color="red">{{alarmCount.alarm2}}</a-tag>
              <a-tag v-if="menu.path === '/ipDeviceAlarm' && alarmCount.alarm3 > 0" color="red">{{alarmCount.alarm3}}</a-tag>
              <span>
                {{ menu.name }}
              </span>
            </router-link>
          </a-menu-item>
          <a-sub-menu v-else :key="'sub-' + index">
            <template #title>
              <span>
                <!-- <laptop-outlined /> -->
                {{ menu.name }}
              </span>
            </template>
            <a-menu-item v-for="child in menu.children" :key="child.path">
              <router-link :to="child.path">
                <a-tag v-if="child.path === '/moreIpAlarm' && alarmCount.alarm1 > 0" color="red">{{alarmCount.alarm1}}</a-tag>
                <a-tag v-if="child.path === '/moreDeviceAlarm' && alarmCount.alarm2 > 0" color="red">{{alarmCount.alarm2}}</a-tag>
                <a-tag v-if="child.path === '/ipDeviceAlarm' && alarmCount.alarm3 > 0" color="red">{{alarmCount.alarm3}}</a-tag>
                <span>
                  {{ child.name }}
                </span>
              </router-link>
              <template v-if="child.hot">
                <FireFilled style="color: red"/>
              </template>
            </a-menu-item>
          </a-sub-menu>
        </template>

      </a-menu>
    </a-layout-sider>
  </div>
</template>

<script>
import {defineComponent, reactive, ref, watch} from 'vue'
import {
  FireFilled, HomeOutlined, TeamOutlined, SafetyCertificateOutlined, AlertOutlined,
  SettingOutlined, HeartOutlined, CrownOutlined, SoundOutlined, WalletOutlined,
  CreditCardOutlined, BarChartOutlined, ToolOutlined, AppstoreOutlined, BranchesOutlined
} from '@ant-design/icons-vue'
// import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons-vue'
import SidebarTitle from './sidebarTitle.vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { getMenus } from '@/api/admin-user'
import { menu } from '@/utils/menu'
import {getAlarmList, getIndexAlarmCount} from "@/api/ulog";
import {useRouter} from "vue-router";

export default defineComponent({
  name: 'Sidebar',
  components: {
    // UserOutlined,
    // LaptopOutlined,
    // NotificationOutlined,
    FireFilled,
    SidebarTitle
  },
  setup (props, { emit }) {
    const collapsed = ref(false)

    const store = useStore()

    const menuList = ref([])
    const newMenuList = ref([])
    const localMenu = ref(menu)
    const newLocalMenu = ref(menu)

    const alarmCount = ref({})

    const initMenus = () => {
      getMenus().then(res => {
        if (res.success) {
          // const { data } = res
          // menuList.value = localMenu.value.concat(data)

          menuList.value = localMenu.value.concat(res.data.menu)
          newMenuList.value = newLocalMenu.value.concat(res.data.newMenu)
          if (res.data.loginVO) {
            store.dispatch("setUserInfo", res.data.loginVO);
          }

        } else {
          message.error(res.message)
        }
      }).catch(error => {
        message.error(error.message)
      }).finally(() => {
      })

      queryAlarm()

      setInterval(() => {
        queryAlarm()
      },60000)
    }

    const queryAlarm = () => {
      getIndexAlarmCount().then(res => {
        if (res.success) {
          const { data } = res
          alarmCount.value.alarm1 = data.alarm1
          alarmCount.value.alarm2 = data.alarm2
          alarmCount.value.alarm3 = data.alarm3
        } else {
          alarmCount.value.alarm1 = 0
          alarmCount.value.alarm2 = 0
          alarmCount.value.alarm3 = 0
        }
      }).catch(error => {
        message.error(error.message)
      })
    }

    // 调用列表
    initMenus()

    watch(() => store.getters.getSidebarCollapsed, (newVal, oldValue) => {
      // console.log(newVal, oldValue)
      collapsed.value = store.getters.getSidebarCollapsed
    })

    const handleClick = (routerObj) => {
      emit('openTab', routerObj)
    }

    const router = useRouter()
    let selectedKeys = ref([router.currentRoute.value.path]);
    watch(() =>router.currentRoute.value.path,(newValue,oldValue)=> {
      selectedKeys.value[0] = newValue;
    },{ immediate: true })

    // 一级菜单图标。键必须与 Mongo permissionEntity 里 level=1 的 title 完全一致，
    // 对不上就退回 AppstoreOutlined（原来的实现返回 undefined，渲染成 <i class="undefined">）。
    const iconMap = {
      '概览': HomeOutlined,
      '用户管理': TeamOutlined,
      '内容审核': SafetyCertificateOutlined,
      '风控与安全': AlertOutlined,
      '运营配置': SettingOutlined,
      '匹配与玩法配置': HeartOutlined,
      'PGC与女神': CrownOutlined,
      '推广与超推': SoundOutlined,
      '财务管理': WalletOutlined,
      '支付配置': CreditCardOutlined,
      '数据统计': BarChartOutlined,
      '流量分配': BranchesOutlined,
      '系统管理': ToolOutlined
    }

    const getIcon = (menu) => iconMap[menu.name] || AppstoreOutlined

    return {
      alarmCount,
      selectedKeys,
      openKeys: ref([]),
      collapsed,
      menuList,
      newMenuList,
      handleClick,
      getIcon
    }
  }
})
</script>

<style lang="less" scoped>
@import '@/style/variables.less';

.sidebar {
  width: @sidebar-w;
  background: @bg-surface;
  border-right: 1px solid @border-1;
  padding-top: 4px;
}

// a-menu 在 scoped 里要穿透
.sidebar :deep(.ant-menu) {
  border-right: 0;
  padding: 0 8px 16px;
  font-size: 13px;
}

.sidebar :deep(.ant-menu-submenu-title),
.sidebar :deep(.ant-menu-item) {
  height: 36px;
  line-height: 36px;
  margin: 2px 0 !important;
  border-radius: @radius-sm;
  color: @text-2;
  transition: background .15s ease, color .15s ease;
}

.sidebar :deep(.ant-menu-submenu-title:hover),
.sidebar :deep(.ant-menu-item:hover) {
  color: @brand-500;
  background: @bg-hover;
}

// 二级项缩进一点，层级才读得出来
.sidebar :deep(.ant-menu-sub .ant-menu-item) {
  padding-left: 40px !important;
  font-size: 13px;
}

.sidebar :deep(.ant-menu-item-selected) {
  background: @brand-50 !important;
  color: @brand-600 !important;
  font-weight: 500;
  &::after { display: none; }   // 右侧那根竖条，换成整块底色更利落
}

.sidebar :deep(.ant-menu-submenu-selected > .ant-menu-submenu-title) {
  color: @brand-600;
}

.sidebar :deep(.ant-menu-submenu-arrow) { color: @text-4; }
.sidebar :deep(.anticon) { font-size: 15px; }
.sidebar :deep(.ant-menu-inline .ant-menu-submenu-title) { font-weight: 500; }
</style>
